// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-locale--is-rtl .v-date-picker-controls__month{flex-direction:row!important}.date-picker-btn{border-radius:50px;box-shadow:0 0 4px 0 #00000040;width:100%}.close-icon{position:absolute;left:8px;top:8px;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
